import setFilters from 'store/reducer-utils/setFilters'
import { DROP_DATA, SET_DATA, SET_FILTERS, SET_LOADING } from 'modules/AccountsMarketplace/Products/types'
import { updateObject } from 'utils/updateObject'

const initialState = {
  loading: true,
  filters: null,
  products: [],
  pagination: {
    offset: 0,
    limit: 50,
    total: 0,
  },
}

const setProductsFilter = (state, action) => {
  const filteredPayload = state?.filters
    ? [...action.payload].filter(
        (filter) => Object.keys(state.filters).indexOf(filter.fieldName) > -1,
      )
    : action.payload

  return setFilters(state, { ...action, payload: filteredPayload })
}

const setProducts = (state, { payload }) =>
  updateObject(state, {
    pagination: payload.pagination,
    products: [...state.products, ...payload.list],
    loading: false,
  })

const setLoading = (state, { payload }) => updateObject(state, payload)

const dropData = (state) =>
  updateObject(state, {
    products: [],
    loading: true,
    pagination: { ...initialState.pagination },
  })

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_FILTERS:
      return setProductsFilter(state, action)
    case SET_DATA:
      return setProducts(state, action)
    case SET_LOADING:
      return setLoading(state, action)
    case DROP_DATA:
      return dropData(state)
    default:
      return state
  }
}
